import { Position } from 'src/types'

export const positionChecker = (position: Position) => {
  const isPitcher = position === 'pitcher'
  const isCatcher = position === 'catcher'
  const isFirst = position === 'first'
  // const isInfielder = position === 'infielder'
  const isOutfielder = position === 'outfielder'
  const isGlove = ['pitcher', 'infielder', 'outfielder'].includes(position)
  const isMitt = ['first', 'catcher'].includes(position)

  return {
    isPitcher,
    isCatcher,
    isFirst,
    // isInfielder, // 未使用
    isOutfielder,
    isGlove,
    isMitt
  }
}

export const backStyleChecker = (backStyle: string) => {
  const isFirstBackStyle = backStyle === 'firstBackStyle'
  return {
    isFirstBackStyle
  }
}

export const ysrModelChecker = (productNumber: string) => {
  const isSequentialRollModel = ['SS016G', '2B041G', 'BS016B', 'SS016JI'].includes(productNumber)
  return {
    isSequentialRollModel
  }
}
